import React from 'react';
import { gettext } from '@eb/i18n';
import { Toggle } from '../../../../components/Toggle';
import { getOnlineEventsOption } from '@eb/location-autocomplete';

const OnlineEventsFilterButton = (props) => {
    return (
        <div className="eds-align--center eds-align--space-between eds-l-pad-right-3 eds-l-pad-left-2">
            <p className="eds-l-pad-right-6">
                {gettext('Search for online events')}
            </p>
            <Toggle
                shouldNotOptimisticUpdate={!props.isAuthenticated}
                onClick={() =>
                    props.selectedFilters.isOnline
                        ? props.handleRemoveOnlineFilter()
                        : props.handleApplyOnlineFilter({
                              ...getOnlineEventsOption(),
                              placeId: null,
                          })
                }
                renderDisplayValue={(isActive) =>
                    isActive ? gettext('On') : gettext('Off')
                }
                isActive={props.selectedFilters.isOnline}
            />
        </div>
    );
};

export default OnlineEventsFilterButton;
